import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Graph from "../../components/molecules/Graph";
import { actions as breadCrumbActions } from "../../components/organisms/BreadCrumb/breadCrumb.reducers";
import { selectSelectedDataModel } from "./index";

const { setSelectedTab } = breadCrumbActions;

const DataModelAnalyticsGraph = () => {
  const dispatch = useDispatch();
  const selectedDataModel = useSelector(selectSelectedDataModel);

  const apidata = [
    {
      data: [33, 53, 85, 41, 44, 65, 71, 81, 65, 80, 25, 70, 100],
    },
    {
      data: [12, 25, 35, 51, 54, 76, 90, 81, 89, 82, 30, 43, 82, 72, 95],
    },
  ];
  const data2 = [
    { data: [26, 33, 53, 85, 41, 110, 44, 65, 71, 81, 65, 82, 42, 59] },
  ];

  useEffect(() => {
    dispatch(setSelectedTab(selectedDataModel));
  }, [dispatch, selectedDataModel]);

  return (
    <div className="scrollbar content overflow-auto p-6 flex-1">
      <div className="h-2/4 bg-gray-800 rounded-lg mb-4">
        <div className="chart-header p-4">
          <h6 className="text-base font-bold mb-1 text-gray-50">
            API Requests
          </h6>
          <h3 className="text-xl font-bold text-gray-50 mb-1">
            246 Requests / Day (Average)
          </h3>
          <p className="text-sm text-gray-400">
            The daily average of API requests provides insight into your
            project&apos;s usage.
          </p>
        </div>
        <div className="h-3/4 chart-body p-4">
          <Graph chartData={data2} />
        </div>
      </div>
      <div className="h-2/4 bg-gray-800 rounded-lg">
        <div className="chart-header p-4">
          <h6 className="text-base font-bold mb-1 text-gray-50">
            API Bandwidth
          </h6>
          <h3 className="text-xl font-bold text-gray-50 mb-1">
            4 MB / Day (Average)
          </h3>
          <p className="text-sm text-gray-400">
            The daily average of API bandwidth for both reads (purple) and
            writes (pink).
          </p>
        </div>
        <div className="h-3/4 chart-body p-4">
          <Graph chartData={apidata} />
        </div>
      </div>
    </div>
  );
};

export default DataModelAnalyticsGraph;
